module.exports = __webpack_public_path__ + "static/media/Angle-down.c1a208ba.svg";